import { createAction, props } from '@ngrx/store';
import { PatientReport } from '../../models/patient-report';
import { ReportsListPosition } from '../../models/reports-list-position';

export const getReports = createAction('[Reports] Get Reports');

export const getReportsSuccess = createAction(
  '[Reports] Get Reports Success',
  props<{
    reports: PatientReport[];
  }>()
);

export const getReportsFailure = createAction('[Reports] Get Reports Failure', props<{ error: unknown }>());

export const nextPage = createAction('[Reports] Next Page');

/**
 * Re-request the page that just failed, without touching `pageNumber` or the loaded entities.
 *
 * Needed as its own action rather than reusing `nextPage`, which *increments* `pageNumber` — retrying
 * with it would skip the page that failed. `getReports` is no good either: it `removeAll`s and
 * restarts at page 1, discarding what the patient has already scrolled through.
 */
export const retryPage = createAction('[Reports] Retry Page');

/** Remember where the list was before a report opens on its own route, so the way back lands there. */
export const rememberListPosition = createAction(
  '[Reports] Remember List Position',
  props<{ position: ReportsListPosition }>()
);

/** One-shot: the list consumed the remembered position, so a later visit loads fresh. */
export const clearListPosition = createAction('[Reports] Clear List Position');

export const recordReportPrintEvent = createAction(
  '[Reports] Record Print Event',
  props<{ patientId: number; reportId: number; reportType: string }>()
);

export const recordReportPrintEventSuccess = createAction('[Reports] Record Print Event Success');

export const recordReportPrintEventFailure = createAction(
  '[Reports] Record Print Event Failure',
  props<{ error: unknown }>()
);
